import { __decorate } from "tslib";
import addModel from '@blade-sxp/device-management/components/add-model.vue';
import { tagList, removeTag, removeScene, editScene, editTag, sceneList } from '@blade-sxp/device-management/api/device-management/index';
import { Message } from 'element-ui';
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    type;
    addDialogVisible = false;
    loading = false;
    inputText = '';
    className = 'popout-box';
    total = 0;
    tagOptions = [];
    disableButton = true;
    mounted() {
        this.getTagList();
    }
    handleDb() { }
    get returnTitle() {
        if (this.type === 'keyArea') {
            return `${this.$t('keyArea')}`;
        }
        else {
            return `${this.$t('label')}`;
        }
    }
    changeItem(item) {
        this.disableButton = false;
        this.$set(item, 'disabled', false);
        if (this.inputText.trim() === String(item?.name).trim()) {
            return;
        }
        if (this.inputText !== '') {
            this.loading = true;
            if (this.type === 'keyArea') {
                let paramScene = {
                    id: item.id,
                    sceneName: this.inputText,
                };
                editScene(paramScene)
                    .then((res) => {
                    if (res) {
                        Message.success(`${this.$t('editSuccessfullys')}`);
                        item.name = this.inputText;
                    }
                })
                    .finally(() => {
                    this.getTagList();
                });
            }
            else {
                let paramTag = {
                    id: item.id,
                    tagName: this.inputText,
                };
                editTag(paramTag)
                    .then((res) => {
                    if (res) {
                        Message.success(`${this.$t('editSuccessfullys')}`);
                        item.name = this.inputText;
                    }
                })
                    .finally(() => {
                    this.getTagList();
                });
            }
        }
        else {
            Message.error(`${this.$t('msgErr')}`);
        }
    }
    deleteItem(item) {
        if (this.type === 'label') {
            removeTag(String(item.id)).then((res) => {
                Message.success(`${this.$t('deletedSuccessfully')}`);
                this.disableButton = false;
                this.getTagList();
            });
        }
        else {
            removeScene(String(item.id)).then((res) => {
                Message.success(`${this.$t('deletedSuccessfully')}`);
                this.disableButton = false;
                this.getTagList();
            });
        }
    }
    handleClose() {
        this.className = 'popout-box-out';
        setTimeout(() => {
            this.$emit('update:dialogVisible', false);
            this.$emit('addSuccess', this.type);
        }, 600);
    }
    addLabel() {
        if (this.total === 50) {
            if (this.type === 'keyArea') {
                Message.error(`${this.$t('addkeyAreaMsg')}`);
                return;
            }
            else {
                Message.error(`${this.$t('addLabelMsg')}`);
                return;
            }
        }
        this.addDialogVisible = true;
    }
    onEdit(item) {
        this.$set(item, 'disabled', true);
        this.inputText = String(item.name);
        this.$nextTick(() => {
            this.$refs[`item${item.id}`][0].focus();
        });
    }
    submit() {
        this.$emit('update:dialogVisible', false);
        this.$emit('addSuccess', this.type);
    }
    addSuccess() {
        this.disableButton = false;
        this.getTagList();
    }
    getTagList() {
        let param = {
            page: 1,
            size: 999,
        };
        this.loading = true;
        if (this.type === 'label') {
            tagList(param)
                .then((res) => {
                this.tagOptions = res.list ?? [];
                this.tagOptions.map((item) => {
                    this.$set(item, 'disabled', false);
                });
                this.total = res.total;
            })
                .finally(() => {
                this.loading = false;
            });
        }
        else {
            sceneList(param)
                .then((res) => {
                this.tagOptions = res.list ?? [];
                this.tagOptions.map((item) => {
                    this.$set(item, 'disabled', false);
                });
                this.total = res.total;
            })
                .finally(() => {
                this.loading = false;
            });
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
default_1 = __decorate([
    Component({
        name: 'editModel',
        components: {
            addModel,
        },
        i18n: {
            messages: {
                en: {
                    addLabel: 'Add Label',
                    addkeyArea: 'Add KeyArea',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    label: 'Label',
                    keyArea: 'Key area',
                    popconfirm: 'yes',
                    popcancel: 'no',
                    deletedSuccessfully: 'Deleted successfully',
                    editSuccessfullys: 'Modified successfully',
                    title: 'All 2 Devices will lose the label,Are you sure delete this Area?',
                    addLabelMsg: 'Add up to 50 Labels',
                    addkeyAreaMsg: 'Add up to 50 keyArea',
                    msgErr: 'Field cannot be empty',
                    deletedLabelMsg: 'All {msg} Devices will lose the label,Are you sure delete this label ?',
                    deletedKeyAreaMsg: 'All {msg} Devices will lose the Area,Are you sure delete this Area?',
                },
                zh: {
                    addLabel: '增加标签',
                    addkeyArea: '增加重点区域',
                    confirm: '确定',
                    cancel: '取消',
                    label: '标签',
                    popconfirm: '确定',
                    popcancel: '取消',
                    keyArea: '重点区域',
                    deletedSuccessfully: '删除成功',
                    editSuccessfullys: '修改成功',
                    msgErr: '字段不能为空',
                    title: '所有2台设备都将失去标签，您确定要删除此区域吗？',
                    addLabelMsg: '最多添加50个标签',
                    addkeyAreaMsg: '最多添加50个区域',
                    deletedLabelMsg: '有 {msg} 设备会失去该标签,确定删除该标签吗?',
                    deletedKeyAreaMsg: '有 {msg} 设备会失去该区域,确定删除该区域吗?',
                },
            },
        },
    })
], default_1);
export default default_1;
